import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import emailjs from '@emailjs/browser';
import React, { useState, useRef } from 'react';
import './Contact.css';
import { Helmet } from "react-helmet";


const Contact = () => {
  const workingHours = [
    { day: 'Luni', hours: '09:00 - 19:30', isActive: true },
    { day: 'Marți', hours: '09:00 - 19:30', isActive: false },
    { day: 'Miercuri', hours: '09:00 - 19:30', isActive: false },
    { day: 'Joi', hours: '09:00 - 19:30', isActive: false },
    { day: 'Vineri', hours: '09:00 - 19:30', isActive: false },
    { day: 'Sâmbătă', hours: 'Închis', isActive: false, isClosed: true },
    { day: 'Duminică', hours: 'Închis', isActive: false, isClosed: true }
  ];

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    tipmobila: '',
    message: ''
  });

  const [status, setStatus] = useState('');
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_ije7bdn', 'template_fk1o16i', form.current, 'r0TmJS0QkhYbtIT-1')
      .then(() => {
        setStatus('Mesaj trimis cu succes!');
        setFormData({
          name: '',
          email: '',
          phoneNumber: '',
          tipmobila: '',
          message: ''
        });
      })
      .catch(() => {
        setStatus('Eroare la trimiterea mesajului.');
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <>
     <Helmet>
        <title>Contact Mobila Sector 2 București</title>
        <meta name="description" content="Contactează-ne pentru mobilă la comandă în Sector 2 București. Proiecte personalizate și consultanță gratuită." />
        <meta name="keywords" content="contact mobila, mobila sector 2, mobila București, comanda mobila" />
      </Helmet>
    <div>
      <Navbar />
      <div className="program-contact-container">
        {/* Program de Lucru Section */}
        <div className="section-card">
          <div className="section-header">
            <div className="icon-wrapper clock-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12,6 12,12 16,14" />
              </svg>
            </div>
            <h2 className="section-title">Program de Lucru</h2>
          </div>

          <div className="working-hours">
            {workingHours.map((schedule, index) => (
              <div
                key={index}
                className={`hour-row ${schedule.isActive ? 'active' : ''} ${schedule.isClosed ? 'closed' : ''}`}
              >
                <span className="day-name">{schedule.day}</span>
                <span className={`hours-time ${schedule.isClosed ? 'closed-text' : ''}`}>
                  {schedule.hours}
                </span>
              </div>
            ))}
          </div>

          <div className="schedule-note">
            * Orarul poate varia în zilele de sărbătoare
          </div>
        </div>

        {/* Contact Information Section */}
        <div className="section-card">
          <div className="section-header">
            <div className="icon-wrapper phone-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
            </div>
            <h2 className="section-title">Informații Contact</h2>
          </div>

          <div className="contact-info">
            <div className="contact-item1">
              <div className="contact-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
              </div>
              <div onClick={() => window.location.href = "tel:+40729981434"}
  style={{ cursor: "pointer" }} className="contact-details">
                <span className="contact-label">Telefon</span>
                <span className="contact-value"><a style={{color:'black'}} href="tel:+40729981434">Suna acum!</a></span>
              </div>
            </div>

            <div className="contact-item1">
              <div className="contact-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </div>
              <div className="contact-details">
                <span className="contact-label">Adresă</span>
                <div className="address-info">
                  <span className="contact-value"></span>
                  <span className="contact-value">București, Sector 2</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="trade-account-container">
        <div className="content-wrapper">
          {/* Secțiunea imagine */}
          <div className="image-section">
            <img
              style={{ width: '330px' }}
              src="https://i.pinimg.com/1200x/cc/44/5a/cc445a268f64f19b5db7da7e391320bb.jpg"
              alt="Camera de zi mobilă"
            />
          </div>

          {/* Formular */}
          <form ref={form} onSubmit={sendEmail} className="form-section">
            <h1 className="form-title">Contactează-ne</h1>

            <div className="trade-form">
              <div className="form-grid">
                <div className="form-row">
                  <div className="input-group">
                    <input
                      type="text"
                      name="name"
                      placeholder="Nume"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-input"
                      required
                    />
                  </div>
                  <div className="input-group">
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-input"
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="input-group">
                    <input
                      type="tel"
                      name="phoneNumber"
                      placeholder="Număr de telefon"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      className="form-input"
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="input-group">
                    <select
                      name="tipmobila"
                      value={formData.tipmobila}
                      onChange={handleChange}
                      className="form-select"
                      required
                    >
                      <option value="">Alege tipul de mobilă</option>
                      <option value="bucatarie">Mobilă bucătărie</option>
                      <option value="dormitor">Mobilă Dormitor</option>
                      <option value="dulap">Dulap</option>
                      <option value="riflaje-interior">Riflaje interior</option>
                      <option value="riflaje-perete">Riflaje perete</option>
                      <option value="dulap-usi-glisante">Dulap cu uși glisante și oglindă</option>
                    </select>
                  </div>
                </div>

                <div className="form-row full-width">
                  <div className="input-group">
                    <textarea
                      name="message"
                      placeholder="Mesaj"
                      value={formData.message}
                      onChange={handleChange}
                      className="form-textarea"
                      rows="4"
                    ></textarea>
                  </div>
                </div>
              </div>

              <button type="submit" className="submit-button">
                Trimite
              </button>
              {status && <p>{status}</p>}
            </div>
          </form>
        </div>
      </div>

      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d45563.34051335506!2d26.107840188377015!3d44.459642407483294!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1f8e7288fb565%3A0x80ecf2e8b912cc1e!2sSector%202%2C%20Bucharest!5e0!3m2!1sen!2sro!4v1754906693769!5m2!1sen!2sro"
        width="100%"
        height="450"
        style={{ border: 0, padding: '20px' }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Harta locatie"
      ></iframe>

      <Footer />
    </div>
    </>
  );
};

export default Contact;
